<template>
  <div>
    <v-card max-width="300" elevation="0">
      <v-card-text class="pa-0">
        <v-card-text class="color-wallet" fill-dot rigth>
          <span style="color: #FFFFFF">{{
            dinheiro
              ? new Intl.NumberFormat("de-DE").format(dinheiro) + " Kzs"
              : ""
          }}</span>
        </v-card-text>
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="dinheiro"
            :rules="moneyTrans"
            label="Valor que deseja carregar (Kz)"
            required
            filled
            :disabled="disabled"
            type="number"
            autofocus
          ></v-text-field>
          <v-card-actions>
            <v-btn
              color="deep-purple lighten-2"
              text
              block
              @click="setConfirmMCX"
              :loading="loading"
            >
              <v-icon>mdi-plus</v-icon>
              Carregar carteira
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "FormCreditWallet",
  data: () => ({
    disabled: false,
    showNotify: false,
    dialog: false,
    dinheiro: "",
    valid: true,
    value: true,
    loading: false,
    moneyTrans: [
      v => !!v || "Este campo é requerido",
      v => /(^[0-9]*$)/.test(v) || "Valor requerido",
      v => /^([1-9][0-9]{3,6})$/gim.test(v) || "Apenas aprtir de 1.000 Kz"
    ]
  }),
  methods: {
    setConfirmMCX() {
      if (this.$refs.form.validate()) {
        const payload = {
          target: true,
          close: false,
          amount: this.dinheiro
        };
        this.$store.dispatch("setConfirmCreditWallet", payload);
      }
    }
  }
};
</script>

<style scoped>
.color-wallet {
  min-height: 80px;
  background-color: #26a69a;
  text-align: center;
  padding-top: 20px;
  display: block;
  font-size: 18px;
}
</style>
